module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Regular-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Regular-webfont.eot
// module id = 683
// module chunks = 0